import { FC } from 'react';

import { Box, Button, DialogActions, DialogContent, Typography, useTheme } from '@mui/material';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import BaseModalWrapper from '@components/share/modal/baseModalWrapper';

type ConfirmPurchaseBundleDialogProps = {
  isOpen: boolean;
  onClose: typeof noop;
  handleConfirm: typeof noop;
};

const ConfirmPurchaseBundleDialog: FC<ConfirmPurchaseBundleDialogProps> = ({ isOpen, onClose, handleConfirm }) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  return (
    <BaseModalWrapper open={isOpen} onClose={onClose} paperStyle={{ width: 450 }}>
      <DialogContent sx={{ px: { xs: 0, md: 2 }, pb: 2 }}>
        <Box display="flex" justifyContent="center" mb={3}>
          <FontAwesomeIcon
            style={{ fontSize: '48px' }}
            color={theme.palette.textV2.disabled}
            icon="fa-light fa-circle-exclamation"
          />
        </Box>

        <Typography variant="h4" sx={{ whiteSpace: 'pre-wrap', textAlign: 'center', mb: 2 }}>
          {t('bundle_detail.header_banner.confirm_purchase.dialog.title')}
        </Typography>

        <Typography variant="body1lanna" component="p" sx={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
          {t('bundle_detail.header_banner.confirm_purchase.dialog.description')}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          display: { xs: 'flex', sm: 'grid' },
          gridTemplateColumns: { sm: '1fr 1fr' },
          flexDirection: 'column-reverse',
          gap: { xs: 2, sm: 3 },
        }}
        disableSpacing
      >
        <Button fullWidth variant="outlined" onClick={onClose}>
          {t('bundle_detail.header_banner.confirm_purchase.dialog.cancel')}
        </Button>

        <Button fullWidth variant="contained" onClick={handleConfirm}>
          {t('bundle_detail.header_banner.confirm_purchase.dialog.confirm')}
        </Button>
      </DialogActions>
    </BaseModalWrapper>
  );
};

export default ConfirmPurchaseBundleDialog;
